<div id="catalogDetailComponent">
  <div class="p-0 profile-pg">
    <div class="ellipse-locations desktop">
      <img src="/assets/img/ellipse1.png" class="ellipse1" />
      <img src="/assets/img/ellipse2.png" class="ellipse2" />
      <img src="/assets/img/ellipse3.png" class="ellipse3" />
      <img src="/assets/img/ellipse4.png" class="ellipse4" />
    </div>
    <div class="header">
      <div class="row m-0 p-0 position-relative">
        <div class="d-flex justify-content-center align-items-center">
          <img src="/assets/img/logo.svg" class="desktop" />
          <img src="/assets/img/logo-mb.svg" class="mobile" />
        </div>
        <a href="index.html">
          <div class="top-teddy-btn mobile">
            <img src="/assets/img/profile-btn-mb.svg" />
          </div>
        </a>
      </div>
    </div>

    <div class="row m-0 p-0 position-relative my-5 profile-details content-section">
      <div class="teddy-profile d-flex justify-content-center align-items-center flex-column">
        <img src="/assets/img/teddy-2-full.png" class="image-showed" />
        <div class="slider-item">
          <div class="item-details">
            <div class="d-flex justify-content-center align-items-center mobile pt-4">
              <img src="/assets/img/icon-profile.svg" style="width: 54px; height: 57px" />
            </div>
            <div class="px-sm-4 px-3 pt-sm-5 pt-4">
              <a href="index.html">
                <div class="teddy-btn desktop">
                  <img src="/assets/img/profile-btn.svg" />
                </div>
              </a>

              <h2 class="text-uppercase ps-sm-4">Say Hello to</h2>
              <h1 class="color-gradient-pale ps-sm-4">Minted Teddy #376</h1>
              <!-- <p class="ps-sm-4">Wherever you go, no matter what the weather, always bring your own sunshine</p> -->
            </div>
            <div class="teddy-details px-sm-4 px-3 my-5">
              <h3 class="color-pale-yellow text-uppercase heading ps-sm-4">Properties</h3>
              <div class="my-4 row m-0 p-0 position-relative ps-sm-4">
                <div class="col-sm-2 p-0 col-4">
                  <h3 class="color-pale-yellow mb-0">Skin</h3>
                  <label>Red</label>
                </div>
                <div class="col-sm-2 p-0 col-4">
                  <h3 class="color-pale-yellow mb-0">Helmet</h3>
                  <label>Silver</label>
                </div>
                <div class="col-sm-2 p-0 col-4">
                  <h3 class="color-pale-yellow mb-0">Nose</h3>
                  <label>Black</label>
                </div>
                <div class="col-sm-6 p-0 col-4 mt-sm-0 mt-3">
                  <h3 class="color-pale-yellow mb-0">Background</h3>
                  <label>Black</label>
                </div>

                <div class="col-sm-2 p-0 col-4 mt-sm-4 mt-3">
                  <h3 class="color-pale-yellow mb-0">Rarity</h3>
                  <label>234</label>
                </div>
                <div class="col-sm-2 p-0 col-4 mt-sm-4 mt-3">
                  <h3 class="color-pale-yellow mb-0">Eyes</h3>
                  <label>Black</label>
                </div>
                <div class="col-sm-2 p-0 col-4 mt-sm-4 mt-3">
                  <h3 class="color-pale-yellow mb-0">Mouth</h3>
                  <label>Black</label>
                </div>
                <div class="col-sm-6 p-0 col-4 mt-sm-4 mt-3">
                  <h3 class="color-pale-yellow mb-0">Necklace</h3>
                  <label>Silver</label>
                </div>
              </div>
            </div>
            <div class="position-absolute desktop" style="right: 60px; bottom: 120px">
              <img src="/assets/img/icon-profile.svg" style="width: 54px" />
            </div>
            <div class="d-flex align-items-center justify-content-center py-sm-3">
              <div class="d-flex ms-sm-auto theme-buttons">
                <button
                  class="btn theme-btn-black mx-sm-4 my-sm-0 my-3 d-flex align-items-center justify-content-center"
                >
                  <span class="">View on Opensea&nbsp;</span>
                  <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M1.05772 9.13632L1.12002 9.03855L4.87084 3.17035C4.88331 3.15092 4.9008 3.13521 4.92145 3.12488C4.94211 3.11455 4.96517 3.10999 4.9882 3.11167C5.01124 3.11335 5.03339 3.12122 5.05232 3.13444C5.07126 3.14766 5.08627 3.16575 5.09579 3.18679C5.72246 4.59126 6.2632 6.33776 6.00999 7.42529C5.90184 7.87258 5.60566 8.47849 5.27228 9.03855C5.22902 9.12017 5.18173 9.20005 5.13155 9.27705C5.11979 9.29451 5.10389 9.30878 5.08527 9.31859C5.06665 9.3284 5.04589 9.33345 5.02484 9.33329H1.16731C1.06349 9.33329 1.00293 9.22082 1.05772 9.13632Z"
                      fill="white"
                    />
                    <path
                      d="M17.7776 10.2267V11.1553C17.7776 11.2089 17.7451 11.2562 17.6978 11.277C17.4074 11.4016 16.4133 11.8578 16 12.4326C14.9451 13.9005 14.1393 16 12.3377 16H4.82221C2.15862 16 0 13.8342 0 11.1614V11.0757C0 11.0045 0.0576786 10.9468 0.128911 10.9468H4.31867C4.40144 10.9468 4.46229 11.0238 4.45479 11.1054C4.4253 11.3824 4.47732 11.6619 4.60447 11.9097C4.72629 12.1561 4.91458 12.3636 5.14809 12.5086C5.38159 12.6537 5.651 12.7305 5.92588 12.7305H8V11.1112H5.94953C5.92553 11.1109 5.90206 11.104 5.88165 11.0914C5.86123 11.0788 5.84465 11.0608 5.83368 11.0395C5.8227 11.0181 5.81776 10.9942 5.81937 10.9702C5.82098 10.9463 5.82909 10.9232 5.84283 10.9035C5.86532 10.8695 5.89041 10.8343 5.91694 10.7939C6.18447 10.4089 6.43373 10.0114 6.66388 9.60288C6.85191 9.27412 7.03417 8.92285 7.18068 8.57044C7.21038 8.5067 7.23403 8.44153 7.25768 8.37779C7.29776 8.26532 7.33929 8.16006 7.369 8.05479C7.39841 7.96597 7.42235 7.87253 7.446 7.78515C7.5155 7.4858 7.5452 7.16885 7.5452 6.84009C7.5452 6.71117 7.53944 6.57621 7.52733 6.4473C7.52156 6.30656 7.50368 6.16582 7.4858 6.02509C7.47204 5.89886 7.45279 5.77329 7.42812 5.64874C7.39724 5.4594 7.35778 5.27156 7.30988 5.0858L7.29344 5.01485C7.25768 4.88594 7.22826 4.76309 7.18673 4.63417C7.07208 4.23958 6.94055 3.85008 6.7925 3.46676C6.74059 3.31997 6.68147 3.17924 6.62235 3.0385C6.53497 2.82653 6.44585 2.63417 6.36453 2.45191C6.323 2.36885 6.28753 2.29329 6.25205 2.21629C6.21249 2.12965 6.17144 2.0437 6.12891 1.95847C6.09921 1.89503 6.06518 1.83562 6.04153 1.77621L5.78803 1.30815C5.78009 1.29398 5.7765 1.27779 5.77773 1.2616C5.77895 1.24541 5.78492 1.22993 5.7949 1.21712C5.80488 1.20431 5.81842 1.19473 5.83382 1.18958C5.84922 1.18443 5.86579 1.18394 5.88147 1.18818L7.46676 1.61788H7.47109C7.47397 1.61788 7.4757 1.61932 7.47686 1.61932L7.68594 1.677L7.9155 1.74218L8 1.76583V0.823648C8 0.368854 8.36453 0 8.81471 0C9.03994 0 9.24441 0.0917087 9.3912 0.241384C9.53771 0.391348 9.6297 0.59553 9.6297 0.823937V2.22235L9.79841 2.26965C9.81225 2.27397 9.8253 2.28049 9.83706 2.28897C9.87859 2.32012 9.93799 2.36597 10.0133 2.42221C10.0727 2.4695 10.1364 2.52747 10.2134 2.58659C10.366 2.70973 10.5479 2.86806 10.7481 3.05032C10.8014 3.09647 10.8534 3.14376 10.9009 3.19106C11.1881 3.4553 11.4623 3.73315 11.7229 4.02365C11.8001 4.11103 11.8757 4.19986 11.9527 4.29329C12.0297 4.38818 12.1113 4.48133 12.1823 4.57476C12.2757 4.69935 12.3764 4.82826 12.4637 4.96294C12.5053 5.02668 12.5526 5.09185 12.5926 5.15559C12.7051 5.32574 12.8043 5.50223 12.8992 5.67844C12.9393 5.76006 12.9808 5.84888 13.0163 5.93626C13.1216 6.17188 13.2043 6.41211 13.2577 6.65177C13.2741 6.70368 13.2859 6.75991 13.2917 6.81038V6.82221C13.3096 6.89344 13.3156 6.969 13.3214 7.046C13.346 7.29304 13.332 7.54241 13.2799 7.78515C13.257 7.89004 13.2278 7.99347 13.1925 8.09488C13.157 8.19582 13.1216 8.30079 13.0754 8.4C12.9861 8.60992 12.8796 8.8121 12.757 9.00447C12.7169 9.07541 12.6696 9.15097 12.6221 9.22221C12.5701 9.29776 12.5171 9.369 12.4695 9.4385C12.4043 9.52732 12.3348 9.62076 12.2636 9.70382C12.2001 9.7912 12.1347 9.87859 12.0637 9.95559C11.9685 10.0693 11.8708 10.1809 11.7704 10.2901C11.711 10.3599 11.6473 10.4311 11.5821 10.4949C11.5187 10.5658 11.4532 10.6296 11.3941 10.689C11.2949 10.7882 11.2118 10.8652 11.1423 10.9289L10.9794 11.0786C10.9551 11.0996 10.9241 11.1112 10.892 11.1112H9.62941V12.7305H11.2176C11.5718 12.7303 11.9144 12.6036 12.1834 12.3732C12.2769 12.2919 12.6841 11.9391 13.1657 11.4074C13.1818 11.3894 13.2029 11.3765 13.2262 11.3704L17.613 10.1021C17.6322 10.0967 17.6524 10.0958 17.6721 10.0996C17.6917 10.1033 17.7102 10.1115 17.7261 10.1236C17.742 10.1357 17.7549 10.1512 17.7638 10.1691C17.7727 10.187 17.7773 10.2067 17.7774 10.2267H17.7776Z"
                      fill="white"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="minted-bg">
      <h1 class="font-300 text-uppercase font-400 color-gradient-pale font-opacity">Minted Teddy</h1>
      <!--
            <marquee>
                <h1 class="font-300 text-uppercase font-400 color-gradient-pale font-opacity">Minted Teddy Minted Teddy</h1>
            </marquee>
-->
    </div>
  </div>
</div>
